import React, { useState, useRef, useEffect } from "react";
import searchIcon from "../../../assets/common/search-icon.svg";
import tick from "../../../assets/dashboard/tick.svg";

const TableSearch = ({
    searchTerm,
    setSearchTerm,
    searchField,
    setSearchField,
    fields,
    onSearchChange,
}) => {
    const [open, setOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setOpen(false);
                setDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const selectedLabel =
        fields.find((f) => f.value === searchField)?.label || "Select";

    return (
        <div ref={wrapperRef} className="relative flex items-center">
            {/* ICON ONLY */}
            {!open && (
                <button
                    onClick={() => setOpen(true)}
                    className="group w-14 h-9 border border-secondary rounded-md flex items-center justify-center hover:bg-[linear-gradient(-80deg,#136BF0_0%,#0C49A6_100%)] transition-all duration-200"
                >
                    <img
                        src={searchIcon}
                        alt="search"
                        className="w-4 h-4 transition duration-300 group-hover:brightness-0 group-hover:invert"
                    />
                </button>
            )}

            {/* EXPANDED SEARCH */}
            {open && (
                <div className="flex items-center gap-2 animate-fadeIn">
                    {/* Main Search Box */}
                    <div className="flex items-center w-[310px] h-9 border border-[#2F6FED] rounded-lg px-2 bg-white transition-all duration-300 focus-within:ring-2 focus-within:ring-blue-200">

                        {/* Input */}
                        <input
                            autoFocus
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                onSearchChange();
                            }}
                            placeholder=""
                            className="flex-1 h-full px-2 outline-none text-sm"
                        />

                        {/* Dropdown Selector */}
                        <div className="relative">
                            <button
                                onClick={() => setDropdownOpen((prev) => !prev)}
                                className="flex items-center gap-1 shadow-md px-3 py-[2px] rounded-md text-sm font-bold"
                            >
                                {selectedLabel}
                                <span className="text-xs">
                                    {dropdownOpen ? "▲" : "▼"}
                                </span>
                            </button>

                            {dropdownOpen && (
                                <div className="absolute right-0 top-full mt-2 w-[160px] p-2 bg-white border rounded-lg shadow-lg z-[9999]">
                                    {fields.map((field) => (
                                        <div
                                            key={field.value}
                                            onClick={() => {
                                                setSearchField(field.value);
                                                setDropdownOpen(false);
                                                onSearchChange();
                                            }}
                                            className={`flex gap-1 items-center justify-center px-4 py-2 text-sm cursor-pointer hover:bg-lightBlue rounded-md ${searchField === field.value ? "bg-lightBlue" : ""
                                                }`}
                                        >
                                            {searchField === field.value && <img src={tick} alt="tick" className="w-2 h-2" />}
                                            {field.label}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    <button
                        onClick={() => {
                            setSearchTerm("");
                            onSearchChange("");
                            setOpen(false);
                            setDropdownOpen(false);
                        }}
                        className="group w-14 h-9 border border-secondary rounded-md flex items-center justify-center hover:bg-[linear-gradient(-80deg,#136BF0_0%,#0C49A6_100%)] transition-all duration-200"
                    >
                        <img
                            src={searchIcon}
                            alt="search"
                            className="w-4 h-4 transition duration-300 group-hover:brightness-0 group-hover:invert"
                        />
                    </button>
                </div>
            )}
        </div>
    );
};

export default TableSearch;